// Imports
var ___CSS_LOADER_API_IMPORT___ = require("./node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block_rich-text_invert-colors .block__body a{color:#fff!important}#sticky-button a{background-color:#a6343b}.box_outline{border:2px solid #ddd}@media only screen and (max-width:991px){.block.block_main-nav .block__body .navbar .navbar_nav--center>.navbar_item .navbar_link{color:#333!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
